/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Speakers_Metrics_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Speaker metrics export failed: {error}" |
*
* @param {Speakers_Metrics_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_export_failed_toast = /** @type {((inputs: Speakers_Metrics_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Speaker metrics export failed: ${i?.error}`)
});